import { Button, Table, Tooltip } from "antd";
import React, { useState } from "react";
import { columnsTableMenu as columns } from "./config";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { EyeSVGIcon } from "pages/Login/Login.config";
import ModalAgree from "../Modal/ModalAgree";
import ModalDisAgree from "../Modal/ModalDisAgree";
import { setIdConsultantInfo } from "redux/reducer/consultantAndFragment";

const ConsultantInfo = (props) => {
  const showModalAgree = useAppSelector(
    (e) => e.consultantAndFragment.isShowModalAgree
  );
  const showModalDisAgree = useAppSelector(
    (e) => e.consultantAndFragment.isShowModalDisAgree
  );

  const lichSuTuVan = useAppSelector((e) => e.consultantAndFragment.data);

  const dispatch = useAppDispatch();
  const [isShowModalAgree, setIsShowModalAgree] = useState(showModalAgree);
  const [isShowModalDisAgree, setIsShowModalDisAgree] =
    useState(showModalDisAgree);

  columns.find((e) => e.dataIndex === "action").render = (t, r, i) => {
    return (
      <Tooltip title="Xem chi tiết">
        <Button onClick={() => handleOpenDetail(r)} icon={<EyeSVGIcon />} />
      </Tooltip>
    );
  };

  const handleOpenDetail = async (r) => {
    if (r.type === 0) {
      dispatch(setIdConsultantInfo(r.id));

      return setIsShowModalDisAgree({
        type: "old",
        isShow: true,
      });
    } else {
      dispatch(setIdConsultantInfo(r.id));

      return setIsShowModalAgree({
        type: "old",
        isShow: true,
      });
    }
  };

  return (
    <div>
      <div className="header">Thông tin tư vấn</div>
      <Table
        columns={columns}
        dataSource={lichSuTuVan?.lichSuTuVanDtos || []}
        bordered
        pagination={false}
        scroll={{ x: "100%", y: 300 }}
      />

      {isShowModalAgree.type === "old" && (
        <ModalAgree
          isShowModalAgree={isShowModalAgree}
          setIsShowModalAgree={setIsShowModalAgree}
        />
      )}
      {isShowModalDisAgree.type === "old" && (
        <ModalDisAgree
          isShowModalDisAgree={isShowModalDisAgree}
          setIsShowModalDisAgree={setIsShowModalDisAgree}
        />
      )}
    </div>
  );
};

export default ConsultantInfo;
